import React from 'react'
import Select from 'react-select';
import {
  sentenceCase,
} from "change-case";
import {
    success,
    warning,
    successNotification,
    error,
    errorNotification,
    warningNotification,
  } from "../notification/notifications";

class CustomSelect extends React.Component {

  // constructor(props) {
  //   super(props);
  // }

  onChange = (option) => {
    this.props.form.setFieldValue(
      this.props.field.name,
      this.props.isMulti ? (option).map((item) => item.value) : (option).value
    );
    if (this.props.handleCallback) {
      setTimeout(() => {
        this.props.handleCallback(option, this.props.form);
      }, 500)
    }
  };

  getValue = () => {
    if (this.props.options) {
      return this.props.isMulti
        ? this.props.options.filter(option => this.props.field?.value?.indexOf(option.value) >= 0)
        : this.props.options.find(option => option.value === this.props.field.value);
    } else {
      return this.props.isMulti ? [] : ("");
    }
  };

  render() {
    const customStyles = {
      // container: provided => ({
      // ...provided,
      // height: 300
      // }),
      control: provided => ({
        ...provided,
        height: 100,
        boxShadow: '0px 2px 9px #f4e1c9',
        border: '1px solid #fbc583 !important',
        overflowX: 'scroll',
       
      })
    };
    return (
      <>
        {/* // <Select
      //   id={this.props.name}
      //   name={this.props.name}
      //   options={this.props.options}
      //   multi={true}
      //   onChange={this.handleChange}
      //   onBlur={this.handleBlur}
      //   value={this.props.value}
      // />
      // className={this.props.className} */}
        <Select
          isDisabled={true}
          styles={customStyles}
          name={this.props.field.name}
          value={this.getValue()}
          onChange={this.props.onChange ? this.props.onChange : this.onChange}
     
          placeholder={this.props.placeholder}
          options={this.props.options}
          isMulti={this.props.isMulti}
        />
        {/* <pre>
          {JSON.stringify(this.props.error, null, 2)}
          {JSON.stringify(this.props.touched, null, 2)}
        </pre> */}
        {this.props.error && (
          <div className='validation'>{this.props.error}</div>
        )}
      </>
    );
  }
}

export default CustomSelect;

export const createOptions = (options, value, label) => {
  const mappedOptions = [];

  options.forEach((option, index) => {
    mappedOptions.push({ value: options[index][value], label: sentenceCase(options[index][label]) })
  });

  return mappedOptions;
}